export default defineAppConfig({
    ui: {
        primary: "amazon",
        gray: "cool",
        input: {
            variant: {
                underline: "bg-transparent text-gray-900 dark:text-white border-b border-{color}-400 dark:border-{color}-300 focus:ring-0 focus:border-0 focus:shadow-[none] focus:border-b-2 focus:border-{color}-500 dark:focus:border-{color}-400 rounded-none focus:border-amazon-500"
            }
        },
        button: {
            base: "group",
            icon: {
                base: "group-hover:animate-bounceTop"
            },
            padding: {
                "2xs": "px-2.5 py-1",
                xs: "px-4 py-1.5",
                sm: "px-5 py-1.5",
                md: "px-6 py-2",
                lg: "px-12 py-2.5",
                xl: "px-16 py-3",
                "2xl": "px-20 py-4",
            },
            size: {
                "2xs": "text-xs",
                xs: "text-xs",
                sm: "text-sm",
                md: "text-sm",
                lg: "text-base",
                xl: "text-lg",
                "2xl": "text-2xl",
            },
            default: {
                loadingIcon: "i-svg-spinners-90-ring-with-bg",
            },
        },
        select: {
            variant: {
                underline: 'text-gray-900 dark:text-white border-b border-b-{color}-500 rounded-none',
            }
        },
        container: {
            constrained: 'max-w-screen-xl',
        },
        breadcrumb: {
            ol: 'overflow-x-auto',
            li: 'shrink-0'
        }
    },
});
